module.exports = __webpack_public_path__ + "static/5-2e9ba1b2682593920418b273b1353ec0.jpg";